import moment from "moment";

export const formatDate = (date) =>
  moment(date).format("MMMM, DD YYYY @ hh:mm A");

export const useApplicantHelpers = ({ applicant }) => {
  const socialIdentites = () => {
    return applicant && applicant.identities
      ? applicant.identities.filter((i) => i.isSocial)
      : [];
  };

  const getSocialUrlByName = (connection) => {
    return socialIdentites().filter((i) => i.provider === connection)[0]
      .profileUrl;
  };

  const isSocialConnected = (connection) => {
    return (
      socialIdentites().filter((i) => i.provider === connection).length > 0
    );
  };
  return {
    getSocialUrlByName,
    isSocialConnected,
    socialIdentites: socialIdentites()
  };
};

export const useApplicantActions = ({ applicant, onApplicationAction }) => {
  const onApprove = () => {
    onApplicationAction({
      applicationType: "Approved",
      applicant: { account: applicant }
    });
  };

  const onReject = () => {
    onApplicationAction({
      applicationType: "Rejected",
      applicant: { account: applicant }
    });
  };
  return {
    onApprove,
    onReject
  };
};
